import { type ReactNode } from 'react';
import { PricingTiersReadonly } from '@/components/ui/pricing-tiers-readonly';
import type { CollectorSummary, DailyEarning, Payment } from '../types';
import type { Tier } from '@/hooks/use-pricing';
import type { RankingEntry } from '../utils/bonus-indicators';
import { ActivityChart } from './activity-chart';
import { PaymentHistoryList } from './payment-history-list';
import { PersonalStatsRow } from './personal-stats-row';

function todayCreators(daily: DailyEarning[] | undefined): number {
  if (!daily?.length) return 0;
  const today = new Date().toISOString().slice(0, 10);
  return daily.find((d) => d.date.startsWith(today))?.lead_count ?? 0;
}

export type EarningsData = {
  summary: CollectorSummary;
  baseEarnings: number;
  avgPerDay: number;
  tier: Tier | undefined;
  daily: DailyEarning[] | undefined;
  payments: Payment[];
  rankPosition: number | null;
  creatorsToNext: number | null;
  ranking: RankingEntry[];
  periodCreators: number;
};

type Props = { d: EarningsData };

function HistoryAndPricing({
  payments,
  today,
}: {
  payments: Props['d']['payments'];
  today: number;
}): ReactNode {
  const hasPaid = payments.some((p) => p.status === 'paid');
  const cls = hasPaid ? 'grid grid-cols-1 gap-sm sm:grid-cols-2' : '';
  return (
    <div className={cls}>
      <PaymentHistoryList payments={payments} />
      <PricingTiersReadonly todayCreators={today} />
    </div>
  );
}

export function EarningsSections({ d }: Props): ReactNode {
  const today = todayCreators(d.daily);
  return (
    <>
      <ActivityChart daily={d.daily ?? []} />
      <PersonalStatsRow />
      <HistoryAndPricing payments={d.payments} today={today} />
    </>
  );
}
